import { IconButton } from '@mui/material';
import {useState} from 'react';
import add_icon from '../../../asset/image/add_icon.svg';

interface AddButtonProps {
  handleAddClick?:() => void;
}

const AddButton = (props: AddButtonProps) => {
    const {handleAddClick} = props;
    return(
        <IconButton
            onClick={handleAddClick}
            sx={{
              width: 32,
              height: 32,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={add_icon}></img>
          </IconButton>
    )
}

export default AddButton;